import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '@ajaibid/utils';

const availableColors = [
  'black',
  'blue',
  'green',
  'red',
  'grey',
  'white',
  'yellow',
  'grey-light',
  'blue-darker',
  'yellow-darker',
  'grey-darker',
];
const availableSize = [
  'h1',
  'h2',
  'section',
  'sub-section',
  'tab-bold',
  'tab-regular',
  'body-bold',
  'body-regular',
  'button-large',
  'button-medium',
  'tag-bold',
  'label-regular',
  'dropdown-title-bold',
  'dropdown-title-regular',
  'link-normal',
  'link-underline',
  'placeholder-regular',
  'alert-regular',
  'popup-title-bold',
  'table-header-regular',
  'caption-bold',
];
const forbiddenStyle = ['fontWeight', 'fontSize'];

const Text = ({
  className,
  color,
  size,
  moment,
  momentFormat,
  positive,
  negative,
  bold,
  style,
  children,
  ...rest
}) => {
  const classNameArr = [];
  // eslint-disable-next-line no-unused-vars
  let colorClass = '';
  if (size && availableSize.includes(size)) {
    classNameArr.push(`text-${size}`);
  } else classNameArr.push('text-body-regular');

  if (color && availableColors.includes(color)) {
    colorClass = `text-${color}`;
  }
  if (positive) {
    colorClass = 'positive';
  }
  if (negative) {
    colorClass = 'negative';
  }
  if (colorClass !== '') classNameArr.push(colorClass);
  if (style) {
    // eslint-disable-next-line no-restricted-syntax
    for (const forbid of forbiddenStyle) {
      if (style[forbid]) delete style[forbid];
    }
  }
  return (
    <span className={`${className} ${classNameArr.join(' ')}`} style={style} {...rest}>
      {moment ? formatDate(children, momentFormat) : children}
    </span>
  );
};

// TODO: change props name for moment and momentFormat, since its doesnt sound relevant

Text.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  positive: PropTypes.bool,
  negative: PropTypes.bool,
  bold: PropTypes.bool,
  moment: PropTypes.bool,
  momentFormat: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
};

Text.defaultProps = {
  className: '',
  color: null,
  size: 'normal',
  positive: false,
  negative: false,
  bold: false,
  moment: false,
  momentFormat: 'D MMM YYYY',
  style: null,
  children: null,
};

export default Text;
